"use client";

import React, { useState } from "react";
import { YiedlDrawer } from "./YiedlDrawer";
import { YiedlFooter } from "./YiedlFooter";
import { Menu } from "lucide-react";
import Image from "next/image";

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-yiedl-dark overflow-x-hidden">
      {/* Drawer Sidebar */}
      <YiedlDrawer
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col md:ml-64 overflow-x-hidden">
        {/* Mobile Header with Hamburger */}
        <div className="md:hidden sticky top-0 z-30 bg-yiedl-dark">
          <div className="flex items-center justify-between px-4 h-16">
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="p-2 hover:bg-yiedl-gray-200 rounded-xl transition-colors"
              aria-label="Open menu"
            >
              <Menu className="w-6 h-6 text-white" />
            </button>

            <div className="flex items-center gap-3">
              <Image
                src="https://pulsarmoney.b-cdn.net/quests/campaigns/yield/yield-logo.png"
                alt="Yiedl"
                width={120}
                height={40}
                className="w-auto h-10 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Content with Padding and Rounded Corners */}
        <main className="flex-1 ">
          <div className="bg-black overflow-hidden h-full ">{children}</div>
        </main>

        {/* Footer */}
        <YiedlFooter />
      </div>
    </div>
  );
};
